import rangeService from '../../services/ClassenService/modules/rangeService';

const state = {
  ranges: [],
  rangesFacets: [],
};

const mutations = {};

const getters = {};

const actions = {
  getRanges: ({commit}) => new Promise((resolve, reject) => {
    rangeService.getRanges()
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getRange: ({commit}, rangeId) => new Promise((resolve, reject) => {
    rangeService.getRange(rangeId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  updateRange: ({commit}, rangeId, rangeData) => new Promise((resolve, reject) => {
    rangeService.updateRange(rangeId, rangeData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  deleteRange: ({commit}, rangeId) => new Promise((resolve, reject) => {
    rangeService.deleteRange(rangeId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  addRange: ({commit}, rangeData) => new Promise((resolve, reject) => {
    rangeService.addRange(rangeData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

};

export default {
  state, mutations, getters, actions,
};
